import { Sparkles } from "lucide-react";

export default function ExplainableAiCard({
    title,
    reasoning,
    confidence,
    impact,
    action,
    onApply,
    testid,
}) {
    const pct = Math.round(Math.max(0, Math.min(1, confidence ?? 0)) * 100);
    return (
        <div
            data-testid={testid}
            className="hover-lift rounded-sm border border-border border-l-2 border-l-[hsl(var(--ai))] bg-card p-4"
        >
            <div className="mb-2 flex items-center gap-2">
                <Sparkles className="h-3.5 w-3.5 text-[hsl(var(--ai))]" />
                <div className="mlabel">{title}</div>
            </div>

            <div className="text-[13px] leading-relaxed">{reasoning}</div>

            <div className="mt-3 grid grid-cols-2 gap-3 text-[11px]">
                <div>
                    <div className="mlabel mb-1">Confidence</div>
                    <div className="conf-bar">
                        <span style={{ width: `${pct}%` }} />
                    </div>
                    <div className="mono-num mt-1 text-[11px] font-medium">{pct}%</div>
                </div>
                <div>
                    <div className="mlabel mb-1">Est. Impact</div>
                    <div className="mono-num text-[13px] font-semibold">{impact}</div>
                </div>
            </div>

            {action && (
                <button
                    onClick={onApply}
                    data-testid={`${testid}-apply`}
                    className="mt-3 w-full rounded-sm border border-[hsl(var(--ai))]/30 bg-[hsl(var(--ai))]/[0.08] px-3 py-1.5 text-[12px] font-medium text-[hsl(var(--ai))] transition-colors hover:bg-[hsl(var(--ai))]/[0.14]"
                >
                    {action}
                </button>
            )}
        </div>
    );
}
